import axios from 'axios'

export default {

    /**
     * Get users.
     * @param params
     * @returns {AxiosPromise<any>}
     */
    get(params) {
        return axios.get('/api/users', { params })
    },

    /**
     * Get user data.
     * @param id
     * @returns {AxiosPromise<any>}
     */
    find(id) {
        return axios.get('/api/users/' + id)
    },

    /**
     * Get statistics for the user.
     * @param userId
     * @returns {AxiosPromise<any>}
     */
    statistics(userId) {
        return axios.get('/api/users/' + userId + '/statistics');
    },

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/users.js